<div class="button-container">
  <integrations-connect-to-service [service]="zoom" [connectionInfoKey]="serviceKey" [useAlternateStyling]="true">
    <integrations-connect-element>
      <ng-container [ngTemplateOutlet]="zoomButton" [ngTemplateOutletContext]="{ label: signInText, isMeetingApp: isMeetingApp }"></ng-container>
    </integrations-connect-element>
  </integrations-connect-to-service>
</div>

<ng-template #zoomButton let-label="label" let-cursor="cursor" let-isMeetingApp="isMeetingApp">
  <button
    class="zoom-button-container"
    matStepperNext
    [ngStyle]="{ cursor: cursor || 'pointer' }"
    >
    @if (isMeetingApp !== true) {
      <div class="zoom-icon-container">
        <img
          class="zoom-icon"
          src="https://storage.googleapis.com/meeting-scheduler-prod-public-images/zoom-icon.svg"
          />
      </div>
    }
    <div class="sign-in-text" [class.no-icon]="isMeetingApp === true">
      <span>{{ label }}</span>
    </div>
  </button>
</ng-template>
